import React, { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, Alert } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { getInvoicePdf } from '../../slices/invoices/thunk';
import { createSelector } from "reselect";

const selectInvoiceState = (state) => state.Invoices || {};
const selectInvoiceProperties = createSelector(
  selectInvoiceState,
  (invoice) => ({
    invoicePdf: invoice.invoicePdf || { data: null, loading: false, error: null }
  })
);

const InvoiceModalPdf = ({ isOpen, toggle, invoiceId, invoiceName }) => {

  const dispatch = useDispatch();
  const { invoicePdf } = useSelector(selectInvoiceProperties);
  const { data: pdfUrl, loading, error } = invoicePdf;

  useEffect(() => {
    if (isOpen && invoiceId) {
      dispatch(getInvoicePdf(invoiceId));
    }
  }, [isOpen, invoiceId, dispatch]);

  const handleDownload = () => {
    if (pdfUrl) {
      const a = document.createElement('a');
      a.href = pdfUrl;
      a.download = `invoice_${invoiceName || invoiceId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const handleOpenNewTab = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    }
  };

  const handleClose = () => {
    toggle();
    // Optional: Clean up PDF URL when modal closes
    // dispatch(clearInvoicePdf());
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose} size="xl" centered>
      <ModalHeader toggle={handleClose} className="border-0">
        <i className="ri-file-pdf-line me-2"></i>
        Invoice PDF {invoiceName && `- ${invoiceName}`}
      </ModalHeader>
      
      <ModalBody style={{ padding: 0, height: '80vh' }}>
        {loading && (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="text-center">
              <Spinner color="primary" />
              <p className="mt-3 text-muted">Loading PDF...</p>
            </div>
          </div>
        )}

        {error && (
          <div className="p-4">
            <Alert color="danger">
              <h4 className="alert-heading">Error Loading PDF</h4>
              <p className="mb-0">{error}</p>
            </Alert>
          </div>
        )}

        {pdfUrl && !loading && (
          <iframe
            src={pdfUrl}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="Invoice PDF"
          />
        )}

        {!pdfUrl && !loading && !error && (
          <div className="d-flex justify-content-center align-items-center h-100">
            <p className="text-muted">No PDF available</p>
          </div>
        )}
      </ModalBody>

      {pdfUrl && (
        <ModalFooter className="border-0">
          <Button 
            color="primary" 
            outline
            onClick={handleDownload}
            className="d-flex align-items-center"
          >
            <i className="ri-download-line me-2"></i>
            Download
          </Button>
          <Button 
            color="secondary" 
            outline
            onClick={handleOpenNewTab}
            className="d-flex align-items-center"
          >
            <i className="ri-external-link-line me-2"></i>
            Open in New Tab
          </Button>
          <Button color="secondary" onClick={handleClose}>
            Close
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default InvoiceModalPdf;